/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-01-23 09:29:01
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-02-14 11:22:00
 * @ Description:
 */

import eventBus from './eventBus'

const SESSION_KEY = 'GLOBAL_DATA'

/**
 * 这里是 session 存储数据的类型定义
 * @typedef {{
 *    userId: string;
 *    searchRecordList: string;
 * }} StorageData
 */

// 初始存储数据
// TODO orderType存localStorage里不合理,容易被篡改
const initStorageData = {
  userId: '',
  nickname: '',
  headUrl: '',
  birthday: '',
  cityCode: '',
  gender: '',
  phone: '',
  processedPhone: '',
  searchRecordList: '[]'
}

/**
 * 获取 session
 * @returns {StorageData} session 存储数据
 */
export const getStorage = key => {
  const storageData = window.localStorage.getItem(SESSION_KEY)

  // 没有数据时 设置成初始数据
  if (!storageData) {
    window.localStorage.setItem(SESSION_KEY, JSON.stringify(initStorageData))
    if (!key) {
      return initStorageData
    } else {
      return initStorageData[key]
    }
  } else {
    if (!key) {
      return JSON.parse(storageData)
    } else {
      return JSON.parse(storageData)[key]
    }
  }
}

/**
 * 保存数据到 session 内，会合并已有数据
 * @param {Partial<StorageData>} value 要保存的数据对象
 * @example
 * // 调用前 storage 数据为 { a: "1", b: "2" }
 * // 调用后为 { "a": "123456", b: "2" }
 * setStorage({ a: "123456" });
 */
export const setStorage = value => {
  const data = getStorage()
  const mergedData = {
    ...data,
    ...value
  }
  window.localStorage.setItem(SESSION_KEY, JSON.stringify(mergedData))
  eventBus.emit('storage-change', mergedData)
}

/**
 * 获取storage中存的userId
 * @returns
 */
export function getUserId () {
  const { userId } = getStorage()
  return userId || ''
}

/**
 * 获取storage中存的phone
 * @returns
 */
export function getPhone () {
  const { phone } = getStorage()
  return phone || ''
}

getStorage()
